// tools function
import { humanize } from 'humanize';
export default {

  year(){
    let n = new Date()
    return n.getFullYear()
  },
  
  now(){
    return new Date()    
  },

  unix(){
    return Math.floor((new Date).getTime()/1000)
  },
  
  outdate(unixTimestamp) {
    const currentTime = Math.floor(Date.now() / 1000); 
    return unixTimestamp < currentTime;
  },

  days(unix){
    var timeleft = unix - (new Date()).getTime()/1000;
    return Math.ceil((((timeleft) / 60) / 60) / 24)    
  },

  // 14:45
  only(unix){
    let d = new Date(0)
    d.setUTCSeconds(unix)
    let h = d.getHours()
    let m = d.getMinutes()
    if (m < 10) m = `0${m}`
    return `${h}:${m}` 
  },

  human(){
    return humanize
  },
  
  ago(unix, lang, customtraslate) {
    let langs = {
        en:{now:'',ago:'',next:'in',sec:'s',min:'min',hours:'h',days:'d',month:'m', years:'y'},
    }
    if (!langs[lang]) lang = 'en'
    let translate = langs[lang]
    if (customtraslate) translate = customtraslate
    
    let tt = new Date()
    var sec = Math.round((tt.getTime() / 1000) - unix)
    let back = translate.ago
    let front = translate.next;
    if (sec < 0) {
      sec = sec * -1
      back = ''
    } else {
      front = ''
    }

    if (sec < 0) return translate.now
    if (sec > 0 && sec < 60) return `${front} ${sec}${translate.sec} ${back}`
    if (sec > 60 && sec < 60 * 60) {
      let m = Math.round(sec / 60)
      return `${front} ${m} ${translate.min} ${back}` 
    }
    if (sec >= 60 * 60 && sec < 60 * 60 * 24) {
      let m = Math.round(sec / (60 * 60))
      return `${front} ${m} ${translate.hours} ${back}`
    }
    if (sec >= 60 * 60 * 24 && sec < 60 * 60 * 24 * 30) {
      let m = Math.round(sec / (60 * 60 * 24))
      return `${front} ${m} ${translate.days} ${back}`
    }
    if (sec >= 60 * 60 * 24 * 30 && sec < 60 * 60 * 24 * 365) {
      let m = Math.round(sec / (60 * 60 * 24 * 30))
      return `${front} ${m} ${translate.month} ${back}`
    }
    if (sec >= 60 * 60 * 24 * 365) {
      let m = Math.round(sec / (60 * 60 * 24 * 365))
      return `${front} ${m} ${translate.years} ${back}`
    }
  },

   jsdate(d){
    let mm = d.getMonth() + 1
    let dd = d.getDate()    
    return [
      d.getFullYear(), mm < 10 ? `0${mm}` : mm, dd < 10 ? `0${dd}` : dd].join('-');
  },
  
    unixToJSdate(unix){
      let d = new Date(0)
      d.setUTCSeconds(unix)
      return this.jsdate(d)
    },

}